import { Component, Inject, OnInit } from '@angular/core';
import { Validators, FormGroup, FormBuilder, FormArray, AbstractControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { LibService } from '../../services/libService';
import { TranslatorService } from '../../services/translate.service';
import { BuildingService } from '../../services/building.service';

@Component({
    selector: 'app-add-new-payment-method-modal',
    templateUrl: './add-new-payment-method-modal.component.html',
    styleUrls: ['./add-new-payment-method-modal.component.scss']
})
export class AddNewPaymentMethodModalComponent implements OnInit {

    editMode: boolean = false
    formIsActive: boolean = false
    titleLabel: string = 'ADD_NEW_PAYMENT_METHOD.TITLE'
    textLabel: string = ''
    confirmButtonLabel: any = 'LABEL.ADD'
    cancelButtonLabel: any = 'LABEL.CANCEL'

    item: any = null
    companies: any = []
    toDisable = false
    isNew = true

    type: any = null

    insertMethod: any = 'search'
    subjectBuildingRelationTypes: any = null

    dataSource: any;

    form: FormGroup
    formBuilding: FormGroup

    reasons: any = null

    estimateDeliveryMethods: any = null

    requiresNotesField: boolean = false
    localData: any
    nextStateForCancellation: any = ''

    listOfStatesAvailableForMigration: any = []

    // Tipologie fatturazione disponibili
    tipoFatturazioneOptions = [
        { id: 2, label: 'ADD_NEW_PAYMENT_METHOD.TIPO_ACCONTO' },
        { id: 3, label: 'ADD_NEW_PAYMENT_METHOD.TIPO_RATA' },
        { id: 4, label: 'ADD_NEW_PAYMENT_METHOD.TIPO_SALDO' }
    ]

    selectedTipoForNewStep: number | null = null

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private libService: LibService,
        private translate: TranslatorService,
        public buildingService: BuildingService,
        private fb: FormBuilder,
        public dialogRef: MatDialogRef<AddNewPaymentMethodModalComponent>,
        private dialog: MatDialog
    ) {

        if (data) {
            console.log(data)

            if (data.form) {
                this.form = data.form
            }

        }



    }





    ngOnInit(): void {

        if (this.data.companies) {
            this.companies = this.data.companies
        }


        this.form = this.fb.group({
            label: [null, [Validators.required]],
            PracticeId: [this.data?.PracticeId || null, Validators.required],
            steps: this.fb.array([])
        })


    }

    // Getter per il form array degli steps
    get steps(): FormArray {
        return this.form.get('steps') as FormArray;
    }

    // Ottieni le tipologie disponibili per nuovi step
    getAvailableTypes(): any[] {
        const existingTypes = this.steps.controls.map(step => step.get('TipoFatturazioneId')?.value);

        return this.tipoFatturazioneOptions.filter(option => {
            // ACCONTO (id:2) e SALDO (id:4) possono essere aggiunti solo una volta
            if (option.id === 2 || option.id === 4) {
                return !existingTypes.includes(option.id);
            }
            // RATA (id:3) può essere aggiunta più volte
            return true;
        });
    }

    // Crea un nuovo step
    createStep(tipoFatturazioneId: number): FormGroup {
        const isRataOrSaldo = tipoFatturazioneId === 3 || tipoFatturazioneId === 4;
        const isAcconto = tipoFatturazioneId === 2;
        const isRata = tipoFatturazioneId === 3;
        const isSaldo = tipoFatturazioneId === 4;

        const step = this.fb.group({
            TipoFatturazioneId: [tipoFatturazioneId, Validators.required],
            percentage: [null, [Validators.required, Validators.min(0), Validators.max(100)]],
            endOfWork: [isSaldo ? true : false, Validators.required],
            dayFromEndOfWork: [{ value: 0, disabled: true }, Validators.required],
            monthlyPayment: [false, Validators.required],
            percentageSAL: [isAcconto ? 0 : (isSaldo ? 100 : null), [Validators.required, Validators.min(0), Validators.max(100)]],
            order: [null, Validators.required],
            progressivePercentage: [null, Validators.required],
            label: [null]
        });

        // Gestione endOfWork: abilitato solo per RATA
        if (isAcconto) {
            step.get('endOfWork')?.disable({ emitEvent: false });
        } else if (isSaldo) {
            // Per SALDO: endOfWork sempre true e disabilitato
            step.get('endOfWork')?.setValue(true);
            step.get('endOfWork')?.disable({ emitEvent: false });
            step.get('dayFromEndOfWork')?.enable({ emitEvent: false }); // Abilita dayFromEndOfWork per SALDO
        } else if (isRata) {
            // Per RATA: dayFromEndOfWork sempre abilitato
            step.get('dayFromEndOfWork')?.enable({ emitEvent: false });
        }

        // Per ACCONTO: percentageSAL sempre 0 e disabilitato
        if (isAcconto) {
            step.get('percentageSAL')?.setValue(0);
            step.get('percentageSAL')?.disable({ emitEvent: false });
        }

        // Per SALDO: percentageSAL sempre 100 e disabilitato
        if (isSaldo) {
            step.get('percentageSAL')?.setValue(100);
            step.get('percentageSAL')?.disable({ emitEvent: false });
        }

        // monthlyPayment abilitato solo per RATA
        if (!isRata) {
            step.get('monthlyPayment')?.setValue(false);
            step.get('monthlyPayment')?.disable({ emitEvent: false });
        }

        // Listener per endOfWork (solo per RATA)
        step.get('endOfWork')?.valueChanges.subscribe(value => {
            const currentTipo = step.get('TipoFatturazioneId')?.value;
            if (currentTipo === 3) { // Solo per RATA
                if (value) {
                    step.get('dayFromEndOfWork')?.enable({ emitEvent: false });
                    step.get('monthlyPayment')?.setValue(false, { emitEvent: false });
                    step.get('monthlyPayment')?.disable({ emitEvent: false });
                    // Se endOfWork è true, percentageSAL è sempre 100 e non modificabile
                    step.get('percentageSAL')?.setValue(100, { emitEvent: false });
                    step.get('percentageSAL')?.disable({ emitEvent: false });
                } else {
                    step.get('dayFromEndOfWork')?.setValue(0, { emitEvent: false });
                    // dayFromEndOfWork rimane abilitato per RATA anche se endOfWork è false
                    step.get('monthlyPayment')?.enable({ emitEvent: false });
                    // Se endOfWork è false, riabilita percentageSAL
                    step.get('percentageSAL')?.enable({ emitEvent: false });
                }
                this.updateStepLabel(step);
            }
        });

        // Listener per monthlyPayment (solo per RATA)
        step.get('monthlyPayment')?.valueChanges.subscribe(value => {
            const currentTipo = step.get('TipoFatturazioneId')?.value;
            if (value && currentTipo === 3) {
                step.get('percentageSAL')?.setValue(null, { emitEvent: false });
                step.get('percentageSAL')?.clearValidators();
                step.get('percentageSAL')?.setValidators([Validators.min(0), Validators.max(100)]);
                step.get('percentageSAL')?.updateValueAndValidity({ emitEvent: false });
                step.get('percentageSAL')?.disable({ emitEvent: false });
                step.get('endOfWork')?.setValue(false, { emitEvent: false });
                step.get('endOfWork')?.disable({ emitEvent: false });
            } else if (currentTipo === 3) {
                step.get('percentageSAL')?.clearValidators();
                step.get('percentageSAL')?.setValidators([Validators.required, Validators.min(0), Validators.max(100)]);
                step.get('percentageSAL')?.updateValueAndValidity({ emitEvent: false });
                step.get('percentageSAL')?.enable({ emitEvent: false });
                step.get('endOfWork')?.enable({ emitEvent: false });
            }
            this.updateStepLabel(step);
        });

        // Listener per i campi che influenzano la label
        step.get('percentage')?.valueChanges.subscribe(() => this.updateStepLabel(step));
        step.get('percentageSAL')?.valueChanges.subscribe(() => this.updateStepLabel(step));
        step.get('dayFromEndOfWork')?.valueChanges.subscribe(() => this.updateStepLabel(step));

        // Calcola la label iniziale
        this.updateStepLabel(step);

        return step;
    }

    // Aggiungi un nuovo step
    addStep(): void {
        if (this.selectedTipoForNewStep !== null) {
            const newStep = this.createStep(this.selectedTipoForNewStep);
            this.steps.push(newStep);
            this.reorderSteps();
            this.calculateProgressivePercentages();
            this.selectedTipoForNewStep = null;
        }
    }

    // Rimuovi uno step
    removeStep(index: number): void {
        this.steps.removeAt(index);
        this.reorderSteps();
        this.calculateProgressivePercentages();
    }

    // Riordina automaticamente gli step
    reorderSteps(): void {
        // Crea una copia degli step con i loro indici originali
        const stepsWithIndex = this.steps.controls.map((step, index) => ({
            step: step,
            originalIndex: index,
            tipo: step.get('TipoFatturazioneId')?.value,
            endOfWork: step.get('endOfWork')?.value,
            monthlyPayment: step.get('monthlyPayment')?.value
        }));

        // Ordina: ACCONTO (2) prima, poi RATE (3), poi SALDO (4)
        // Per le RATE: 
        // 1. monthlyPayment == true (pagamenti mensili)
        // 2. endOfWork == false && monthlyPayment == false (rate normali)
        // 3. endOfWork == true (rate a fine lavori)
        stepsWithIndex.sort((a, b) => {
            // Prima ordina per tipo
            if (a.tipo !== b.tipo) {
                return a.tipo - b.tipo;
            }

            // Se entrambi sono RATE (tipo 3), ordina per monthlyPayment e endOfWork
            if (a.tipo === 3 && b.tipo === 3) {
                // 1. Rate con monthlyPayment == true vengono sempre prima
                if (a.monthlyPayment && !b.monthlyPayment) {
                    return -1;
                }
                if (!a.monthlyPayment && b.monthlyPayment) {
                    return 1;
                }

                // 2. Se nessuno ha monthlyPayment, ordina per endOfWork
                // Rate con endOfWork == false vengono prima di quelle con endOfWork == true
                if (!a.monthlyPayment && !b.monthlyPayment) {
                    if (!a.endOfWork && b.endOfWork) {
                        return -1;
                    }
                    if (a.endOfWork && !b.endOfWork) {
                        return 1;
                    }
                }
            }

            return 0;
        });

        // Rimuovi tutti gli step dal FormArray
        while (this.steps.length !== 0) {
            this.steps.removeAt(0);
        }

        // Reinserisci gli step nell'ordine corretto e aggiorna il campo order
        stepsWithIndex.forEach((item, index) => {
            this.steps.push(item.step);
            item.step.get('order')?.setValue(index + 1, { emitEvent: false });
        });
    }

    // Sposta uno step verso l'alto (solo per RATE)
    moveStepUp(index: number): void {
        if (index > 0 && this.canMoveStep(index)) {
            const step = this.steps.at(index);
            const stepAbove = this.steps.at(index - 1);

            // Verifica che entrambi siano RATE
            if (step.get('TipoFatturazioneId')?.value === 3 &&
                stepAbove.get('TipoFatturazioneId')?.value === 3) {
                this.steps.removeAt(index);
                this.steps.insert(index - 1, step);
                this.reorderSteps();
                this.calculateProgressivePercentages();
            }
        }
    }

    // Sposta uno step verso il basso (solo per RATE)
    moveStepDown(index: number): void {
        if (index < this.steps.length - 1 && this.canMoveStep(index)) {
            const step = this.steps.at(index);
            const stepBelow = this.steps.at(index + 1);

            // Verifica che entrambi siano RATE
            if (step.get('TipoFatturazioneId')?.value === 3 &&
                stepBelow.get('TipoFatturazioneId')?.value === 3) {
                this.steps.removeAt(index);
                this.steps.insert(index + 1, step);
                this.reorderSteps();
                this.calculateProgressivePercentages();
            }
        }
    }

    // Verifica se uno step può essere spostato (solo RATE)
    canMoveStep(index: number): boolean {
        const step = this.steps.at(index);
        return step.get('TipoFatturazioneId')?.value === 3;
    }

    // Calcola le percentuali progressive
    calculateProgressivePercentages(): void {
        let cumulative = 0;
        this.steps.controls.forEach(step => {
            const percentage = step.get('percentage')?.value || 0;
            cumulative += percentage;
            step.get('progressivePercentage')?.setValue(cumulative);
        });
    }

    // Listener per i cambiamenti di percentage
    onPercentageChange(): void {
        this.calculateProgressivePercentages();
    }

    // Ottieni il label della tipologia
    getTipoLabel(tipoId: number): string {
        const tipo = this.tipoFatturazioneOptions.find(t => t.id === tipoId);
        return tipo ? tipo.label : '';
    }

    // Valida il form prima del submit
    canSubmit(): boolean {
        if (!this.form.valid || this.steps.length === 0) {
            return false;
        }

        // Verifica che ci sia almeno uno step di tipo SALDO
        const hasSaldo = this.steps.controls.some(step => step.get('TipoFatturazioneId')?.value === 4);
        if (!hasSaldo) {
            return false;
        }

        // Verifica che la somma delle percentuali sia 100
        const totalPercentage = this.steps.controls.reduce((sum, step) => {
            return sum + (step.get('percentage')?.value || 0);
        }, 0);

        if (totalPercentage !== 100) {
            return false;
        }

        // Verifica che la progressivePercentage dell'ultimo step sia 100
        const lastStep = this.steps.at(this.steps.length - 1);
        if (lastStep.get('progressivePercentage')?.value !== 100) {
            return false;
        }

        return true;
    }

    // Submit del form
    onSubmit(): void {
        if (this.canSubmit()) {
            // Prepara i dati per la conferma
            const methodName = this.form.get('label')?.value;
            const stepsList = this.steps.controls.map(step => {
                const order = step.get('order')?.value;
                const label = step.get('label')?.value;
                return `${order}. ${label}`;
            }).join('\n');

            // Mostra dialog di conferma nativo
            const confirmTitle = this.translate.instant('ADD_NEW_PAYMENT_METHOD.CONFIRM_TITLE');
            const confirmNameLabel = this.translate.instant('ADD_NEW_PAYMENT_METHOD.CONFIRM_NAME');
            const confirmStepsLabel = this.translate.instant('ADD_NEW_PAYMENT_METHOD.CONFIRM_STEPS');
            const confirmQuestion = this.translate.instant('ADD_NEW_PAYMENT_METHOD.CONFIRM_QUESTION');
            const confirmMessage = `${confirmTitle}\n\n${confirmNameLabel}: ${methodName}\n\n${confirmStepsLabel}:\n${stepsList}\n\n${confirmQuestion}`;

            if (confirm(confirmMessage)) {
                // Usa getRawValue() per includere anche i campi disabilitati
                const formData = this.form.getRawValue();
                // Assicurati che steps sia un array di oggetti validi
                formData.steps = this.steps.controls.map(step => step.getRawValue());
                this.dialogRef.close(formData);
            }
        }
    }

    // Calcola la somma totale delle percentuali
    getTotalPercentage(): number {
        return this.steps.controls.reduce((sum, step) => {
            return sum + (step.get('percentage')?.value || 0);
        }, 0);
    }

    // Calcola la percentuale di SAL progressiva (massimo percentageSAL tra tutti gli step). Il totale è 100 quando è presente il SALDO
    getTotalPercentageSAL(): number {
        if (this.steps.length === 0) {
            return 0;
        }
        return this.steps.controls.reduce((max, step) => {
            const sal = (step as FormGroup).getRawValue().percentageSAL ?? 0;
            return Math.max(max, sal);
        }, 0);
    }

    // Ottieni la percentuale progressiva dell'ultimo step
    getLastProgressivePercentage(): number {
        if (this.steps.length === 0) {
            return 0;
        }
        return this.steps.at(this.steps.length - 1).get('progressivePercentage')?.value || 0;
    }

    // Verifica se esiste almeno uno step di tipo SALDO
    hasSaldo(): boolean {
        return this.steps.controls.some(step => step.get('TipoFatturazioneId')?.value === 4);
    }

    // Aggiorna la label di uno step in base ai suoi valori
    updateStepLabel(step: FormGroup): void {
        const tipo = step.get('TipoFatturazioneId')?.value;
        const percentage = step.get('percentage')?.value || 0;
        const percentageSAL = step.get('percentageSAL')?.value;
        const endOfWork = step.get('endOfWork')?.value;
        const dayFromEndOfWork = step.get('dayFromEndOfWork')?.value || 0;
        const monthlyPayment = step.get('monthlyPayment')?.value;

        let labelKey = '';
        let params: any = {};

        if (tipo === 2) { // ACCONTO
            labelKey = 'PAYMENT_METHOD_STEP.ACCONTO_START_WORK';
            params = { percentage };
        } else if (tipo === 4) { // SALDO
            if (endOfWork && dayFromEndOfWork > 0) {
                labelKey = 'PAYMENT_METHOD_STEP.SALDO_DAYS_AFTER_END';
                params = { percentage, days: dayFromEndOfWork };
            } else if (endOfWork && dayFromEndOfWork === 0) {
                labelKey = 'PAYMENT_METHOD_STEP.SALDO_END_WORK';
                params = { percentage };
            } else {
                labelKey = 'PAYMENT_METHOD_STEP.SALDO';
                params = { percentage };
            }
        } else if (tipo === 3) { // RATA
            if (monthlyPayment && dayFromEndOfWork > 0) {
                labelKey = 'PAYMENT_METHOD_STEP.MONTHLY_SAL_DAYS';
                params = { percentage, days: dayFromEndOfWork };
            } else if (monthlyPayment) {
                labelKey = 'PAYMENT_METHOD_STEP.MONTHLY_SAL';
                params = { percentage };
            } else if (endOfWork && dayFromEndOfWork > 0) {
                labelKey = 'PAYMENT_METHOD_STEP.RATA_SAL_DAYS_AFTER_END';
                params = { percentage, percentageSAL, days: dayFromEndOfWork };
            } else if (dayFromEndOfWork > 0) {
                labelKey = 'PAYMENT_METHOD_STEP.RATA_SAL_DAYS';
                params = { percentage, percentageSAL, days: dayFromEndOfWork };
            } else if (endOfWork && dayFromEndOfWork === 0) {
                labelKey = 'PAYMENT_METHOD_STEP.RATA_SAL_END_WORK';
                params = { percentage, percentageSAL };
            } else if (percentageSAL !== null && percentageSAL !== undefined) {
                labelKey = 'PAYMENT_METHOD_STEP.RATA_SAL';
                params = { percentage, percentageSAL };
            } else {
                labelKey = 'PAYMENT_METHOD_STEP.RATA';
                params = { percentage };
            }
        }

        const label = labelKey ? this.translate.instant(labelKey, params) : `${percentage}%`;
        step.get('label')?.setValue(label, { emitEvent: false });
    }



}